import { useEffect } from 'react';
import Header from '../components/header_bis';

const stats = [
  {
    number: '22 500',
    label: 'patients en attente\nd\'une greffe en France',
    sub: 'chiffre en constante hausse',
  },
  {
    number: '3',
    label: 'patients décèdent chaque jour\nfaute de greffon disponible',
    sub: 'soit plus de 1 000 morts par an',
  },
  {
    number: '7',
    label: 'vies peuvent être sauvées\npar un seul donneur',
    sub: 'cœur, foie, reins, poumons, pancréas…',
  },
  {
    number: '80%',
    label: 'des Français se disent\nfavorables au don d\'organes',
    sub: '',
  },
  {
    number: '1/2',
    label: 'seulement en a déjà parlé\nà ses proches',
    sub: 'pourtant, c\'est le geste le plus efficace',
  },
];

function StatCard({ number, label, sub }) {
  return (
    <div style={{
      backgroundColor: 'rgba(255,255,255,0.05)',
      borderRadius: '16px',
      padding: '32px 24px',
      textAlign: 'center',
      border: '1px solid rgba(58,166,55,0.2)',
      flex: '1 1 200px',
    }}>
      <div style={{
        fontFamily: 'Consolas, monospace',
        fontSize: 'clamp(36px, 5vw, 45px)',
        fontWeight: 'bold',
        color: '#3AA637',
        lineHeight: 1,
        marginBottom: '14px',
      }}>
        {number}
      </div>
      <div style={{
        fontFamily: 'Consolas, monospace',
        fontSize: '14px',
        color: '#fff',
        lineHeight: 1.6,
        marginBottom: '10px',
        whiteSpace: 'pre-line',
      }}>
        {label}
      </div>
      <div style={{
        fontFamily: 'Consolas, monospace',
        fontSize: '11px',
        color: 'rgba(255,255,255,0.4)',
        letterSpacing: '0.5px',
        fontStyle: 'italic',
      }}>
        {sub}
      </div>
    </div>
  );
}

function SectionTitle({ label, title }) {
  return (
    <div style={{ textAlign: 'center', marginBottom: '48px' }}>
      {label && (
        <span style={{
          fontFamily: 'Consolas, monospace',
          color: '#3AA637',
          fontSize: '12px',
          letterSpacing: '4px',
          textTransform: 'uppercase',
          display: 'block',
          marginBottom: '12px',
        }}>
          {label}
        </span>
      )}
      <div style={{ width: '50px', height: '2px', backgroundColor: '#3AA637', margin: '0 auto 16px' }} />
      <h2 style={{
        fontFamily: 'Consolas, monospace',
        color: '#fff',
        fontSize: 'clamp(20px, 2.5vw, 30px)',
        fontWeight: 'bold',
        margin: '0 0 16px',
        lineHeight: 1.3,
      }}>
        {title}
      </h2>
      <div style={{ width: '50px', height: '2px', backgroundColor: '#3AA637', margin: '0 auto' }} />
    </div>
  );
}

export default function DonOrganesPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <Header alwaysVisible />

      <div style={{ backgroundColor: 'rgb(22, 32, 60)', minHeight: '100vh', paddingTop: '80px' }}>

        {/* ── HERO ─────────────────────────────────────────── */}
        <div style={{
          background: 'linear-gradient(to bottom, rgb(20,28,54) 0%, rgb(27,38,68) 100%)',
          padding: 'clamp(48px, 8vw, 96px) 24px clamp(56px, 10vw, 110px)',
          textAlign: 'center',
          position: 'relative',
        }}>
          <span style={{
            fontFamily: 'Consolas, monospace',
            color: '#3AA637',
            fontSize: '13px',
            letterSpacing: '5px',
            textTransform: 'uppercase',
            display: 'block',
            marginBottom: '20px',
          }}>
            Le Ruban Vert
          </span>

          <h1 style={{
            fontFamily: 'Consolas, monospace',
            color: '#fff',
            fontSize: 'clamp(24px, 4vw, 52px)',
            fontWeight: 'bold',
            margin: '0 0 24px',
            lineHeight: 1.25,
            maxWidth: '820px',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}>
            Naviguer pour sensibiliser<br />au don d'organes
          </h1>

          <div style={{ width: '60px', height: '3px', backgroundColor: '#3AA637', margin: '0 auto 28px' }} />

          <p style={{
            fontFamily: 'Consolas, monospace',
            color: 'rgba(255,255,255,0.7)',
            fontSize: 'clamp(14px, 1.6vw, 18px)',
            lineHeight: 1.85,
            maxWidth: '1000px',
            margin: '0 auto',
          }}>
            En France, on est tous présumés donneur. Mais en pratique, les équipes médicales consultent toujours les proches avant tout prélèvement. Si vos proches ignorent votre position, leur désaccord — même non contraignant légalement — est souvent respecté. Quand on ne sait pas, surtout dans des moments aussi difficile, il est aussi plus facile de dire non pour son proche. Si on en a parlé avant, tout est plus simple. Alors entre proche, on se le dit !
          </p>
        </div>

        {/* Vague */}
        <div style={{ lineHeight: 0, backgroundColor: 'rgb(27,38,68)' }}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 60" preserveAspectRatio="none"
            style={{ display: 'block', width: '100%', height: '60px', transform: 'scaleY(-1)' }}>
            <path fill="rgb(20,28,54)" d="M0,30 C360,60 1080,0 1440,30 L1440,0 L0,0 Z" />
          </svg>
        </div>

        {/* ── CHIFFRES CLÉS ────────────────────────────────── */}
        <div style={{ padding: 'clamp(48px,6vw,80px) clamp(16px,5vw,80px)' }}>
          <SectionTitle label="Les enjeux" title="Des chiffres qui interpellent" />
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '20px',
            maxWidth: '1100px',
            margin: '0 auto',
          }}>
            {stats.map((s, i) => <StatCard key={i} {...s} />)}
          </div>
        </div>

        



        {/* ── HOMMAGE ──────────────────────────────────────── */}
        <div style={{
          background: 'linear-gradient(to bottom, rgb(27,38,68), rgb(20,28,54))',
          borderTop: '1px solid rgba(58,166,55,0.15)',
          padding: 'clamp(56px,8vw,100px) clamp(16px,5vw,80px)',
          textAlign: 'center',
        }}>
          <div style={{ maxWidth: '760px', margin: '0 auto' }}>
            <div style={{ width: '50px', height: '2px', backgroundColor: '#3AA637', margin: '0 auto 20px' }} />
            <span style={{
              fontFamily: 'Consolas, monospace',
              color: '#3AA637',
              fontSize: '12px',
              letterSpacing: '4px',
              textTransform: 'uppercase',
              display: 'block',
              marginBottom: '24px',
            }}>
              Hommage
            </span>
            <h2 style={{
              fontFamily: 'Consolas, monospace',
              color: '#fff',
              fontSize: 'clamp(20px, 2.5vw, 30px)',
              fontWeight: 'bold',
              margin: '0 0 32px',
              lineHeight: 1.4,
            }}>
              À ceux qui ont dit oui
            </h2>
            <p style={{
              fontFamily: 'Consolas, monospace',
              color: 'rgba(255,255,255,0.75)',
              fontSize: '15px',
              lineHeight: '2',
              marginBottom: '24px',
            }}>
              Le don d’organes et de tissus est un acte de solidarité et d’espoir. Chaque vie sauvée est la preuve concrète de la valeur inestimable de ces gestes. Porter le ruban vert, c'est aussi rendre hommage à tous ces donneurs.
            </p>
            <div style={{
              display: 'inline-block',
              borderTop: '1px solid rgba(58,166,55,0.4)',
              borderBottom: '1px solid rgba(58,166,55,0.4)',
              padding: '18px 36px',
              marginBottom: '32px',
            }}>
              <p style={{
                fontFamily: 'Consolas, monospace',
                color: '#3AA637',
                fontSize: 'clamp(14px, 1.6vw, 17px)',
                fontStyle: 'italic',
                margin: 0,
                lineHeight: 1.7,
              }}>
                "On ne donne pas ses organes.<br />
                On donne une vie de plus à quelqu'un qui n'en avait plus."
              </p>
            </div>
            <div style={{ width: '50px', height: '2px', backgroundColor: '#3AA637', margin: '0 auto' }} />
          </div>
        </div>

        {/* ── PHOTO FINALE ─────────────────────────────────── */}
        <div style={{
          position: 'relative',
          width: '100%',
          maxHeight: '850px',
          overflow: 'hidden',
        }}>
          <img
            src="/IMG_4480_flip.jpg"
            alt="Naviguer pour le don d'organes"
            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
          />
          <div style={{
            position: 'absolute', inset: 0,
            background: 'linear-gradient(to bottom, rgba(22,32,60,0.05) 0%, rgba(22,32,60,0.3) 100%)',
            display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
            padding: '48px 24px',
          }}>
            <p style={{
              fontFamily: 'Consolas, monospace',
              color: '#fff',
              fontSize: 'clamp(16px, 2vw, 24px)',
              fontStyle: 'italic',
              textAlign: 'center',
              maxWidth: '780px',
              lineHeight: 1.65,
              textShadow: '0 2px 12px rgba(0,0,0,0.7)',
              margin: 0,
            }}>
              "Hisser les voiles pour le don d'organes : chaque sortie en mer, c'est une occasion d'en parler !"
            </p>
          </div>
        </div>

      </div>
    </>
  );
}
